import { UserColumns } from './UserColumns';

export const UserListColums = [
  UserColumns.id,
  UserColumns.login,
  UserColumns.name,
  UserColumns.role,
  UserColumns.state
];
